import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ThankYou = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 2,
            width: '100%',
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 80,
              color: 'success.main',
              mb: 2,
            }}
          />
          <Typography variant="h4" component="h1" gutterBottom>
            Thank You for Your Purchase!
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            We appreciate your business and are excited to help you with your annuity needs.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Please check your email for the complete lead details. If you have any questions,
            don't hesitate to reach out to our support team.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default ThankYou; 